export function creditNoteTabs(notes: { id: string; number: string }[]): { id: string; label: string }[] {
  if (!notes.length) return [];
  return [
    { id: 'invoice', label: 'Invoice' },
    ...notes.map((note) => ({ id: note.id, label: notes.length === 1 ? 'Credit note' : note.number })),
  ];
}
